import {Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../../core/services/header.service';
import {AuthService} from '../../../core/security/auth.service';
import {merge} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {MessagingAutomationService as MessagingAutomationApiService} from '../../../api/services/messaging-automation.service';
import {AutomationListDatasource} from './automation-list.datasource';
import {RouterHelper} from '../../../core/utilities/router-helper';
import {RolesEnum} from '../../../core/security/roles.enum';
import {AutomationModel} from '../../../api/models/automation-model';
import {DateTime} from 'luxon';
import {DateUtils} from '../../../core/utilities/date-time-helpers';
import {AutomationSettingsRequest} from '../../../api/models/automation-settings-request';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { MatChipRow } from '@angular/material/chips';
import { PhoneNumberPipe } from '../../../core/pipes/phone-number.pipe';

@Component({
    selector: 'app-automation-list-grid',
    templateUrl: './automation-list-grid.component.html',
    styleUrls: ['./automation-list-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        RouterLink,
        NgFor,
        MatChipRow,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        PhoneNumberPipe,
    ],
})
export class AutomationListGridComponent implements OnDestroy, OnInit {
  displayedColumns: string[] = [
    'name',
    'isEnabled',
    'keyword',
    'replyMessage',
    'phoneNumbers',
  ];
  @Input() filterChangeEvent: EventEmitter<any> = new EventEmitter<any>();

  additionalFilter: any = {};
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dataSource: AutomationListDatasource;

  hasEditAccess = false;
  detailsUrl: string;


  constructor(public dialog: MatDialog,
              public headerService: HeaderService,
              public authService: AuthService,
              private messagingAutomationApiService: MessagingAutomationApiService) {

    const detailsModule = RouterHelper.getRouteByComponent('ProMessagingAutomationListComponent');
    this.detailsUrl = this.headerService.themePrefix + detailsModule.path.replace('/list', '');

    this.authService.currentUser.subscribe((data) => {
      this.hasEditAccess = this.authService.hasAccess([RolesEnum.MessagingAutomation_Edit, RolesEnum.MessagingAutomation_Delete]);
    });
  }

  ngOnInit() {
    this.dataSource = new AutomationListDatasource(this.messagingAutomationApiService);

    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): AutomationSettingsRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  ngOnDestroy() {
  }

  isScheduleEnable(dataItem: AutomationModel) {
    const anyActiveIndex = dataItem.schedule.findIndex(x => !!x.isEnabled);

    return anyActiveIndex > -1;
  }

  scheduleActiveDescription(dataItem: AutomationModel) {
    const today = DateTime.local();
    // console.log(today.toFormat('M/dd/yyyy hh:mm a'));
    const currentTime = DateUtils.dateTimeToMinutes(new Date(today.toFormat('M/dd/yyyy hh:mm a')));
    const schedule = dataItem.schedule.find(x => x.isEnabled && x.weekDay === (today.weekday === 7 ? 0 : today.weekday));

    if (schedule) {
      if (currentTime >= schedule.startTime && currentTime <= schedule.endTime) {
        return 'Active now';
      }
    }

    return 'Enabled but not active';
  }
}
